// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Drop files here: PDF, photos, Excel, CSV or Word',
  waiting: 'Sending waits until the files are uploaded.',
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} page',
  pages_other: '{{count}} pages',
  problems: {
    type: "This type of file can't be sent. Send a PDF, a photo (JPG, PNG or HEIC), or an Excel, CSV or Word file.",
    size: 'Over 20 MB. A file can be up to 20 MB.',
    empty: 'This file is empty.',
    count: 'Up to 10 files per message.',
    upload: 'The upload stopped. Try again.',
  },
};
